export default __webpack_public_path__ + "static/Agile-methodology-9b59fe28d487a3e4215a35ff6bd74dc8.webp";